<template>
  <div
    :style="`margin: 0; padding: 0;width:${dispW}px;height:${dispH - 2}px;border:1px solid gray;`"
  >
    <div class="img-container">
      <span class="img-span">Retinal Image ({{ zernikeSet.diameter | numFilter(2) }}mm pupil)</span>
      <img :src="EUrl" class="image" alt />
    </div>
    <div class="img-container">
      <span class="img-span">PSF ({{ zernikeSet.diameter | numFilter(2) }}mm pupil)</span>
      <br />
      <span class="img-span" style="top: 60px">Strehl ratio = {{ ratio | numFilter(3) }}</span>
      <img :src="psfUrl" class="image" alt />
    </div>
    <div style="height: 34%">
      <span class="img-span" style="top: 18px"
        >MTF ({{ zernikeSet.diameter | numFilter(2) }}mm pupil)</span
      >
      <div id="chart" class="image" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import echarts from "echarts";
import { TOPOGRAPHYEVENTS } from "../shared/events";
const chartXLen = 60;
const DEG0 = "0°";
const DEG90 = "90°";
export default {
  name: "ZernikeChart",
  data() {
    return {
      psfUrl: "",
      EUrl: "",
      ratio: 0,
      deg0Data: [],
      deg90Data: [],
      myChart: null,
      chartOptions: {
        title: {
          show: false
        },
        color: [
          "#ff0000",
          "#32CD32",
          "#61a0a8",
          "#d48265",
          "#91c7ae",
          "#749f83",
          "#ca8622",
          "#bda29a",
          "#6e7074",
          "#546570",
          "#c4ccd3"
        ],
        xAxis: {
          type: "value",
          name: "Frequency (cycle/deg)",
          nameLocation: "center",
          nameGap: 25,
          interval: 10,
          nameTextStyle: {
            fontSize: 16
          },
          axisLabel: {
            fontSize: 16
          },
          splitLine: {
            lineStyle: {
              type: "solid",
              width: 1
            }
          },
          min: 0,
          max: chartXLen
        },
        yAxis: {
          type: "value",
          splitLine: {
            lineStyle: {
              type: "solid",
              width: 1
            }
          },
          axisLabel: {
            fontSize: 16
          },
          min: 0,
          max: 1,
          interval: 0.2
        },
        legend: {
          data: [DEG0, DEG90],
          right: 15,
          top: 40,
          orient: "vertical",
          textStyle: { fontSize: 16 }
        },
        grid: {
          top: 35,
          bottom: 45,
          left: 35,
          right: 15
        },
        series: [
          {
            type: "line",
            name: DEG0,
            smooth: true,
            showSymbol: false,
            lineStyle: {
              width: 1
            }
          },
          {
            type: "line",
            name: DEG90,
            smooth: true,
            showSymbol: false,
            lineStyle: {
              width: 1
            }
          }
        ]
      }
    };
  },
  props: {
    dispW: {
      type: Number,
      default: 464
    },
    dispH: {
      type: Number,
      default: window.screen.height - 80 - 10
    },
    zernike: { default: null, type: Object }
  },
  created() {
    this.$bus.$on(TOPOGRAPHYEVENTS.updateZernikeChart, () => {
      this.zernikeChanged();
    });
  },
  computed: {
    ...mapGetters(["zernikeSet"])
  },
  mounted() {
    this.myChart = echarts.init(document.getElementById("chart"), "dark");
  },

  methods: {
    zernikeChanged() {
      if (!this.zernike) return;

      let psfInfo = this.zernike.getPsfInfo();
      this.psfUrl = psfInfo.psfUrl;
      this.EUrl = psfInfo.eUrl;
      this.ratio = psfInfo.ratio;
      this.deg0Data = psfInfo.export0;
      this.deg90Data = psfInfo.export90;

      let tmp0 = [];
      let tmp90 = [];
      let numCount = parseFloat(chartXLen) / parseFloat(18);
      for (let i = 0; i <= 18; i++) {
        tmp0.push([i * numCount, this.deg0Data[i]]);
        tmp90.push([i * numCount, this.deg90Data[i]]);
      }
      this.chartOptions.series[0].data = tmp0;
      this.chartOptions.series[1].data = tmp90;
      if (this.myChart) {
        this.myChart.setOption(this.chartOptions);
      }
    }
  },
  destroyed() {
    this.$bus.$off(TOPOGRAPHYEVENTS.updateZernikeChart);
  },
  filters: {
    numFilter(value, digit) {
      let realVal = "";
      if (!isNaN(value) && value !== "") {
        // 截取当前数据到小数点后两位
        realVal = parseFloat(value)._toFixed(digit);
      } else {
        realVal = "--";
      }
      return realVal;
    }
  }
};
</script>

<style scoped>
.image {
  /* width: 100%; */
  height: 95%;
}
.img-span {
  position: relative;
  top: 20px;
  font-size: 20px;
  z-index: 2;
}
.img-container {
  height: 32.5%;
  border-bottom: 1px solid gray;
  background: black;
}
</style>



// WEBPACK FOOTER //
// src/topography/components/ZernikeChart.vue